// Object.keys is marked as `string[]` in TS intentionally
// This provides an alternative typed method
// See https://stackoverflow.com/a/52856805
export function getTypedObjectKeys<T extends object = object>(o: T) {
  return Object.keys(o) as Array<keyof T>;
}
